import { actionTypes } from '../actions';

const initialState = {
  views: 0,
  timestamp: Date.now()
}

const ad = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_AD_MODAL_VIEWS:
      return { 
        ...state,
        views: action.views,
        timestamp: Date.now()
      };

    default:
      return state;
  }
};

export default ad;



// WEBPACK FOOTER //
// ./src/reducers/ad.js